<template>
  <el-form-item
    class="sm-year-picker w-100"
    :label="label"
    label-position="top"
    :prop="prop"
    :rules="rules"
  >
    <el-date-picker
      ref="pickerRef"
      v-model="selectedYear"
      type="year"
      :placeholder="placeholder"
      :clearable="clearable"
      :disabled="disabled"
      format="YYYY"
      value-format="YYYY"
      :style="inputStyle"
      @blur="handleBlur"
      @change="handleChange"
    >
      <template #prefix v-if="icon">
        <i :class="['text-primary ti', `ti-${icon}`]"></i>
      </template>
      <template #suffix v-if="$slots.suffix">
        <slot name="suffix"></slot>
      </template>
    </el-date-picker>
  </el-form-item>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue'
import type { FormItemRule } from 'element-plus'

interface Props {
  modelValue: number | string | null
  prop?: string
  placeholder?: string
  icon?: string
  disabled?: boolean
  clearable?: boolean
  label: string
  rules?: FormItemRule | FormItemRule[]
  inputStyle?: Record<string, string> | string
}

const props = withDefaults(defineProps<Props>(), {
  prop: undefined,
  placeholder: 'Select year',
  icon: 'calendar',
  disabled: false,
  clearable: false,
  rules: undefined,
  inputStyle: undefined
})

const emit = defineEmits([
  'update:modelValue',
  'blur',
  'change'
])

const pickerRef = ref()
const selectedYear = ref(props.modelValue ? String(props.modelValue) : null)

watch(() => props.modelValue, (newVal) => {
  selectedYear.value = newVal ? String(newVal) : null
})

const handleChange = (val: string | null) => {
  const yearValue = val ? parseInt(val) : null
  emit('update:modelValue', yearValue)
  emit('change', yearValue)
}

const handleBlur = (event: Event) => {
  emit('blur', event)
}

// Expose focus method for parent components
const focus = () => {
  pickerRef.value?.focus()
}

defineExpose({
  focus
})
</script>

<style scoped>

.sm-year-picker :deep(.el-form-item__label) {
  font-weight: 500;
  margin-bottom: 8px;
}

.sm-year-picker :deep(.el-input__wrapper) {
  /* padding: 1px 11px; */
  padding: 20px;
}


</style>